<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH THANH TOÁN</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <!-- <el-button
              type="primary"
              @click="fn_add()"
              icon="el-icon-circle-plus-outline"
              >thêm mới thanh toán</el-button
            > -->
          </div>
        </div>

        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Mã đơn hàng">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['don_hang.ma']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Tên dòng họ">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['dong_ho.ten']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Trạng thái thanh toán">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['trang_thai']
                          "
                          placeholder="Chọn trạng thái"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column label="STT" width="50" fixed>
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Trạng thái" min-width="120" fixed>
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.trang_thai == 'cho_thanh_toan'"
                    class="text-box"
                  >
                    <p class="text-cho-thanh-toan">Chờ thanh toán</p>
                  </div>
                  <div
                    v-if="scope.row.trang_thai == 'da_thanh_toan'"
                    class="text-box"
                  >
                    <p class="text-da-thanh-toan">Đã thanh toán</p>
                  </div>
                  <div v-if="scope.row.trang_thai == 'huy'" class="text-box">
                    <p class="text-huy">Hủy</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="don_hang.ma"
                label="Mã đơn hàng"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="dong_ho.ten"
                label="Tên dòng họ"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="nguoi_thanh_toan"
                label="Người thanh toán"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="phuong_thuc_thanh_toan.ten"
                label="Phương thức thanh toán"
                min-width="150"
              ></el-table-column>
              <el-table-column label="Tổng tiền" min-width="120">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      scope.row.don_hang.tien
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Khách trả phí" min-width="120">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      scope.row.phi.khach
                        ? scope.row.phi.khach
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                        : ""
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="phi.he_thong"
                label="Hệ thống trả phí"
                min-width="120"
              >
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      scope.row.phi.he_thong
                        ? scope.row.phi.he_thong
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                        : ""
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Tiền thanh toán" min-width="120">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      scope.row.tien_thanh_toan
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="thoi_diem.tao"
                label="Thời điểm tạo"
                width="160"
                align="center"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="100"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <!-- <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button> -->
                  <!-- <el-button
                    size="mini"
                    plain
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button> -->
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormThanhToan";
import mushroom from "viettoc-api";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      multipleSelection: [],
      options: [
        {
          value: "cho_thanh_toan",
          label: "Chờ thanh toán",
        },
        {
          value: "da_thanh_toan",
          label: "Đã thanh toán",
        },
        {
          value: "huy",
          label: "Hủy thanh toán",
        },
      ],

      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields:
          "id,don_hang,dong_ho,nguoi_thanh_toan_id,phuong_thuc_thanh_toan,phi,tien_thanh_toan,trang_thai,thoi_diem",
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachThanhToan",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }

      try {
        const response = await mushroom.thanh_toan.listAsync(dataFilter);
        response.result.forEach((item) => {
          item.nguoi_thanh_toan = "";
        });
        console.log(response.result);
        this.loading = false;
        let resData = await this.fn_changeData(response.result);
        this.mData.tableRules.data = resData;
        this.mData.tableRules.total = response.meta.total;
        this.mData.tableRules.page =
          response.meta.offset / response.meta.limit + 1;
      } catch (e) {
        console.log(e);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
        this.loading = false;
      }
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_changeData(data) {
      data.forEach(async (element) => {
        element.thoi_diem.tao = MethodService.formatDate(
          element.thoi_diem.tao,
          "datetime"
        );
        element.nguoi_thanh_toan = await this.fn_getTenNguoiThanhToan(
          element.nguoi_thanh_toan_id
        );
      });
      return data;
    },
    async fn_getTenNguoiThanhToan(id) {
      try {
        const response = await mushroom.nguoi_dung.listAsync({
          filters: ["id=" + id],
        });
        return response.result[0].ten.ho_ten;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;

      this.$router.replace({
        name: "DanhSachThanhToan",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["don_hang.ma"]) {
        this.mData.tableRules.dataSearch.value["don_hang.ma"] =
          this.mData.tableRules.dataSearch.value["don_hang.ma"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["dong_ho.ten"]) {
        this.mData.tableRules.dataSearch.value["dong_ho.ten"] =
          this.mData.tableRules.dataSearch.value["dong_ho.ten"].trim();
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_changeSelect() {
      this.fn_initTable();
    },
    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietThanhToan",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatThanhToan",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    async fn_delete(id) {
      try {
        await mushroom.thanh_toan.deleteAsync({ id: id });
      } catch (e) {
        console.log(e.code);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
      this.fn_initTable();
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
    // fn_add() {
    //   this.$router.push({
    //     name: "ThemMoiThanhToan",
    //   });
    // },
  },
  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_initTable();
  },
};
</script>
<style scoped>
.card {
  min-height: 88vh;
}

.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}
.text-box {
  display: flex;
  justify-content: center;
}
/* .text-cho-thanh-toan,
.text-da-thanh-toan,
.text-huy,
.text-dang-san-xuat,
.text-dang-giao-hang,
.text-da-giao-hang,
.text-hoan-tra,
.text-co-ban,
.text-khoi-dau,
.text-doan-vien,
.text-tiet-kiem,
.text-dong-tam,
.text-thinh-vuong,
.text-ban-sac {
  width: fit-content;
  border-radius: 5px;
  padding: 0 5px;
  color: #fff;
  min-width: 92px;
  text-align: center;
}
.text-cho-thanh-toan {
  background-color: #e6a23c;
}
.text-huy,
.text-hoan-tra {
  background-color: #f56c6c;
}
.text-da-thanh-toan,
.text-da-giao-hang {
  background-color: #67c23a;
}
.text-dang-san-xuat,
.text-dang-giao-hang {
  background-color: #9e52e6;
} */
.text-tiet-kiem {
  background-color: rgb(255 218 218 / 50%);
  color: black;
  border: 1px solid rgb(255 188 188);
}
.text-dong-tam {
  background-color: #fdf1dc;
  color: black;
  border: 1px solid #f8cd83;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  text-align: center;
  border-radius: 5px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
